import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@shared/ui/dialog";
import { Button } from "@shared/ui/button";
import { Label } from "@shared/ui/label";
import { Badge } from "@shared/ui/badge";
import { Star } from "lucide-react";
interface Tip {
  id: string;
  title: string;
  quickSummary: string;
  description: string;
  utilityService: string;
  icon: string;
  isActive: boolean;
  order: number;
  helpfulCount: number;
}



interface TipDetailViewProps {
  tip: Tip | null;
  isOpen: boolean;
  onClose: () => void;
  availableIcons: { name: string; icon: any; value: string }[];
}

export const TipDetailView = ({ tip, isOpen, onClose, availableIcons }: TipDetailViewProps) => {
  const getIconComponent = (iconValue: string) => {
    const iconData = availableIcons.find(icon => icon.value === iconValue);
    return iconData ? iconData.icon : availableIcons[0].icon;
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Tip Details</DialogTitle>
          <DialogDescription>
            View the complete tip information below.
          </DialogDescription>
        </DialogHeader>
        {tip && (
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              {(() => {
                const IconComponent = getIconComponent(tip.icon);
                return <IconComponent className="h-5 w-5" />;
              })()}
              <h3 className="text-lg font-semibold">{tip.title}</h3>
            </div>
            <div>
              <Label className="text-sm font-medium">Quick Summary</Label>
              <p className="mt-1 text-sm text-muted-foreground">{tip.quickSummary}</p>
            </div>
            <div>
              <Label className="text-sm font-medium">Detail Summary</Label>
              <p className="mt-1 text-sm text-muted-foreground whitespace-pre-wrap">{tip.description}</p>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label className="text-sm font-medium">Utility Service</Label>
                <p className="mt-1 text-sm text-muted-foreground">{tip.utilityService}</p>
              </div>
              <div>
                <Label className="text-sm font-medium">Status</Label>
                <div className="mt-1">
                  <Badge variant={tip.isActive ? "default" : "secondary"}>
                    {tip.isActive ? "Active" : "Inactive"}
                  </Badge>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label className="text-sm font-medium">Helpful Count</Label>
                <div className="flex items-center gap-1 mt-1">
                  <Star className="h-3 w-3 text-yellow-500" />
                  <span className="text-sm font-medium">{tip.helpfulCount}</span>
                </div>
              </div>
              <div>
                <Label className="text-sm font-medium">Order</Label>
                <p className="mt-1 text-sm text-muted-foreground">{tip.order}</p>
              </div>
            </div>
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};